import { render, staticRenderFns } from "./productSoftwareApp.vue?vue&type=template&id=d1ea5f24&scoped=true"
import script from "./productSoftwareApp.vue?vue&type=script&lang=js"
export * from "./productSoftwareApp.vue?vue&type=script&lang=js"
import style0 from "./productSoftwareApp.vue?vue&type=style&index=0&id=d1ea5f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ea5f24",
  null
  
)

export default component.exports